import { Input, Textarea, Label, Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@creanizer/ui'
import type { CharacterResult } from '@creanizer/types'

interface BasicInfoEditorProps {
  name: string
  age: string
  gender: string
  role: string
  summary: string
  onChange: (updates: Partial<CharacterResult>) => void
}

export function BasicInfoEditor({
  name,
  age,
  gender,
  role,
  summary,
  onChange
}: BasicInfoEditorProps) {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 gap-4">
        <div>
          <Label htmlFor="name">名前</Label>
          <Input
            id="name"
            value={name}
            onChange={(e) => onChange({ name: e.target.value })}
            placeholder="キャラクター名"
            className="mt-1"
          />
        </div>
        
        <div>
          <Label htmlFor="age">年齢</Label>
          <Input
            id="age"
            value={age}
            onChange={(e) => onChange({ age: e.target.value })}
            placeholder="年齢"
            className="mt-1"
          />
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div>
          <Label htmlFor="gender">性別</Label>
          <Select value={gender} onValueChange={(value) => onChange({ gender: value })}>
            <SelectTrigger id="gender" className="mt-1">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="男性">男性</SelectItem>
              <SelectItem value="女性">女性</SelectItem>
              <SelectItem value="その他">その他</SelectItem>
              <SelectItem value="不明">不明</SelectItem>
            </SelectContent>
          </Select>
        </div>
        
        <div>
          <Label htmlFor="role">役割</Label>
          <Input
            id="role"
            value={role}
            onChange={(e) => onChange({ role: e.target.value })}
            placeholder="役割"
            className="mt-1"
          />
        </div>
      </div>

      <div>
        <Label htmlFor="summary">概要</Label>
        <Textarea
          id="summary"
          value={summary}
          onChange={(e) => onChange({ summary: e.target.value })}
          placeholder="キャラクターの概要"
          rows={4}
          className="mt-1"
        />
      </div>
    </div>
  )
}